<template>
  <v-chip class="ma-1" :color="`#${colors[role.id]}`" small>{{ role.name }}</v-chip>
</template>

<script>
import palette from "google-palette"
export default {
  name: "ChipRole",
  props: {
    role: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      colors: palette("tol", 6),
    }
  },
}
</script>